import { getMilliseconds } from '../utils';
import { fabric } from 'fabric';

const isLocalhost =
  window.origin.includes('localhost') || window.origin.includes('gitpod');

const f = fabric.Image.filters;
function hex(c) {
  var s = '0123456789abcdef';
  var i = parseInt(c);
  if (i == 0 || isNaN(c)) return '00';
  i = Math.round(Math.min(Math.max(0, i), 255));
  return s.charAt((i - (i % 16)) / 16) + s.charAt(i % 16);
}

/* Convert an RGB triplet to a hex string */
function convertToHex(rgb) {
  return hex(rgb[0]) + hex(rgb[1]) + hex(rgb[2]);
}

/* Remove '#' in color hex string */
function trim(s) {
  return s.charAt(0) == '#' ? s.substring(1, 7) : s;
}

/* Convert a hex string to an RGB triplet */
function convertToRGB(hex) {
  var color = [];
  color[0] = parseInt(trim(hex).substring(0, 2), 16);
  color[1] = parseInt(trim(hex).substring(2, 4), 16);
  color[2] = parseInt(trim(hex).substring(4, 6), 16);
  return color;
}

function gradient(colorStart, colorEnd, colorCount) {
  // The beginning of your gradient
  var start = convertToRGB(colorStart);

  // The end of your gradient
  var end = convertToRGB(colorEnd);

  // The number of colors to compute
  var len = colorCount;

  //Alpha blending amount
  var alpha = 0.0;

  var saida = [];

  for (let i = 0; i < len; i++) {
    var c = [];

    alpha += 1.0 / len;

    c[0] = start[0] * alpha + (1 - alpha) * end[0];
    c[1] = start[1] * alpha + (1 - alpha) * end[1];
    c[2] = start[2] * alpha + (1 - alpha) * end[2];

    saida.push(convertToHex(c));
  }

  const hexCol = saida.map((hex) => `#${hex}`);

  return hexCol;
}

const editorConfig = {
  autoSave: isLocalhost ? false : true,
  textureSize: 5168,
  localStorageExpiryInMinutes: 720, // 12 hours
  autoSaveInterval: getMilliseconds('3m'),
  styles: {
    activeControlColor: '#FBC734',
    inactiveControlColor: '#68A3BB',
  },
  defaultFontFamily: 'Open Sans',
  defaultColors: [
    // Neri
    // '#000000',
    // '#555555',
    // '#808080',
    // '#aaaaaa',
    // '#d5d5d5',
    // '#ffffff',

    // // Legno
    // '#473c38',
    // '#c2b19c',
    // '#f0f1f0',
    // '#ffe5b6',
    // '#d5d5d5',
    // '#f0f1f0',

    // // Legno
    // '#8b5a2b',
    // '#ffa54f',
    // '#a0522d',
    // '#cd8500',
    // '#8b4513',

    // // Oro
    // '#a67c00',
    // '#bf9b30',
    // '#ffbf00',
    // '#ffcf40',
    // '#ffdc73',

    // // Blu
    // '#C0E1FF',
    // '#82C0FF',
    // '#00A0E0',
    // '#4181C0',

    // grigi
    ...gradient('#ffffff', '#000000', 12),
    '#941100',
    '#945200',
    '#929000',
    '#4F8F00',
    '#008F00',
    '#009051',
    '#005493',
    '#2d4260',
    '#011993',
    '#531B93',
    '#942193',
    '#941751',
    '#FF2600',
    '#FF9300',
    '#998b67',
    '#8EFA00',
    '#00F900',
    '#00FA92',
    '#00FDFF',
    '#0096FF',
    '#2100F0',
    '#9437FF',
    '#FF40FF',
    '#FF2F92',
    '#FF7E79',
    '#FFD479',
    '#FFFC79',
    '#D4FB79',
    '#73FA79',
    '#73FCD6',
    '#73FDFF',
    '#76D6FF',
    '#0433FF',
    '#D783FF',
    '#FF85FF',
    '#FF8AD8',
    '#640F2B',
    '#3a434e',
    '#646363',
    '#3a434e',
    '#3a434e',
    '#3a434e',
    '#3a434e',
    '#7A81FF',
    '#0C4F9F',
    '#3a434e',
    '#3a434e',
    '#3a434e',
    // // rosso
    // ...gradient('#fade70', '#f1965b', 4),
    // // arancione
    // ...gradient('#fce5cf', '#773f0e', 8),
    // // giallo
    // ...gradient('#fff2ce', '#7e6011', 8),
    // // verde
    // ...gradient('#daead4', '#284d17', 8),
    // // blu
    // ...gradient('#0000fc', '#010185', 8),
    // // celeste
    // ...gradient('#01c5fd', '#016785', 4),

    // // viola
    // ...gradient('#690168', '#fc00f9', 4),

    // // fucsia
    // ...gradient('#fc0289', '#690139', 4),
  ],

  // Classic colors grid - organized with proper vertical shading
  // Each column represents a color family with dark at top, light at bottom
  classicColors: [
    // Row 1: Dark colors (from defaultColors)
    '#333333',
    '#941100',
    '#945200',
    '#929000',
    '#4F8F00',
    '#009051',
    '#005493',
    '#2d4260',
    '#011993',
    '#531B93',
    '#942193',
    '#941751',

    // Row 2: Medium-dark (adjusted for better progression)
    '#666666',
    '#CC1100',
    '#CC7700',
    '#B8B800',
    '#66CC00',
    '#00CC99',
    '#0066CC',
    '#4466AA',
    '#3344CC',
    '#7744CC',
    '#CC44CC',
    '#CC4477',

    // Row 3: Medium colors (from defaultColors - vibrant)
    '#999999',
    '#FF2600',
    '#FF9300',
    '#FFFC00',
    '#8EFA00',
    '#00FA92',
    '#00FDFF',
    '#0096FF',
    '#2100F0',
    '#9437FF',
    '#FF40FF',
    '#FF2F92',

    // Row 4: Light colors (from defaultColors)
    '#CCCCCC',
    '#FF7E79',
    '#FFD479',
    '#FFFC79',
    '#D4FB79',
    '#73FA79',
    '#73FCD6',
    '#73FDFF',
    '#76D6FF',
    '#D783FF',
    '#FF85FF',
    '#FF8AD8',

    // Row 5: Very Light shades (new intermediate row)
    '#E6E6E6',
    '#FFBFBD',
    '#FFE5BD',
    '#FFFFBD',
    '#E5FFBD',
    '#BDFFBD',
    '#BDFFE5',
    '#BDFFFF',
    '#BDE5FF',
    '#E5BDFF',
    '#FFBDFF',
    '#FFBDE5',

    // Row 6: Lightest shades
    '#FFFFFF',
    '#FFE6E6',
    '#FFF0E6',
    '#FFFFE6',
    '#E6FFE6',
    '#E6FFF0',
    '#E6FFFF',
    '#E6F0FF',
    '#F0E6FF',
    '#FFE6FF',
    '#FFE6F5',
    '#FFE6ED',
  ],
  sidebarBackgrounds: {},
  defaultFormats: {},
  sidebarAttachments: {},
  sidebarQuotes: {},
  sidebarImages: {},
  sidebarTags: {},
  scaleFactor: 1.1,
  filters: [
    { name: 'remove-all' },
    {
      filterFunc: () => new f.Grayscale(),
      name: 'grayscale',
      type: 'Grayscale',
    },
    {
      filterFunc: () => new f.Sepia(),
      name: 'sepia',
      type: 'Sepia',
    },
    {
      filterFunc: () => new f.Brownie(),
      name: 'brownie',
      type: 'Brownie',
    },
    {
      filterFunc: () => new f.Vintage(),
      name: 'vintage',
      type: 'Vintage',
    },
    {
      filterFunc: () => new f.Kodachrome(),
      name: 'kodachrome',
      type: 'Kodachrome',
    },
    {
      filterFunc: () => new f.Technicolor(),
      name: 'technicolor',
      type: 'Technicolor',
    },
    {
      filterFunc: () => new f.Polaroid(),
      name: 'polaroid',
      type: 'Polaroid',
    },
  ],
  advancedFilters: [
    {
      filterFunc: (val) =>
        new f.Exposure({
          exposure: parseFloat(val),
        }),
      name: 'exposure',
      type: 'Exposure',
    },
    {
      filterFunc: (val) =>
        new f.ShadowBoost({
          shadowBoost: parseFloat(val),
        }),
      name: 'shadowBoost',
      type: 'ShadowBoost',
    },
    {
      filterFunc: (val) =>
        new f.Brightness({
          brightness: parseFloat(val),
        }),
      name: 'brightness',
      type: 'Brightness',
    },
    {
      filterFunc: (val) =>
        new f.Contrast({
          contrast: parseFloat(val),
        }),
      name: 'contrast',
      type: 'Contrast',
    },
    {
      filterFunc: (val) =>
        new f.Saturation({
          saturation: parseFloat(val),
        }),
      name: 'saturation',
      type: 'Saturation',
    },
    {
      filterFunc: (val) =>
        new f.Blur({
          blur: parseFloat(val),
        }),
      name: 'blur',
      type: 'Blur',
    },
  ],
  filterImageBlend: {
    name: 'blend-image-mask',
    type: 'BlendImage',
    filterFunc: (image, mode = 'mask') =>
      new f.BlendImage({
        image,
        mode,
      }),
  },
  scalingFactors: {
    default: 0.015,
    text: 0.02,
  },
  pagePreviewPlaceholder:
    'https://via.placeholder.com/300x200.png?text=Preview%20Mancante',
  lineColorDark: 'rgba(96, 54, 120, 0.8)',
  lineColorLight: 'rgba(169, 96, 211, 0.35)',
  globalAdminOrgs: [
    'XKyGzJTx53', // dev editor admin
    'BNJkbs2UxG', // prod editor admin
  ],
  excludeFromTrackingOrgsIds: [
    'XKyGzJTx53', // dev editor admin
    'BNJkbs2UxG', // prod editor admin
    'PNgeKjwe16',
  ],
  excludeFromTrackingOrgsNames: ['E2E Tests Srl'],
  superUserIds: [
    'IR0GtWoeoU', // dev
    'MgHnhIktUN', // prod
  ],
  cordogliProjectIds: [
    'aaNS50OSLV', // dev
    'alfp1ZmxbN', // prod
  ],
  additionalJsonProperties: [
    'erasable',
    'giotto',
    'id',
    'lockMovementX',
    'lockMovementY',
    'lockRotation',
    'lockScalingX',
    'lockScalingY',
    'lockUniScaling',
    'isGuideline',
    'orientation',
    'excludeFromExport',
    'excludeFromVisualExport',
    'visible',
    'padding',
  ],
  magicFrameTag: 'cornice magica',
  cordogliTag: 'cordogli',
  magicFrameBgPlaceholder: `${process.env.OFC_CDN_URL}/giotto/placeholder/magicframe/bg.jpg`,
  magicFramePersonPlaceholders: {
    m: `${process.env.OFC_CDN_URL}/giotto/placeholder/magicframe/man.png`,
    f: `${process.env.OFC_CDN_URL}/giotto/placeholder/magicframe/woman.png`,
  },
  snapSettings: {
    // Snap thresholds
    threshold: 7, // General fallback threshold
    objectSnapThreshold: 7, // Distance in pixels for object-to-object snapping
    guidelineSnapThreshold: 7, // Distance in pixels for guideline snapping
    centerLineSnapThreshold: 7, // Distance for canvas center snapping
    canvasEdgeSnapThreshold: 7, // Distance for canvas edge snapping

    // Feature toggles
    enableObjectSnapping: true,
    enableGuidelineSnapping: true,
    enableCenterSnapping: true,
    enableEdgeSnapping: true,
    enableCanvasEdgeSnapping: true,
    enableRulerSnapping: true,
  },
  alignmentSettings: {
    // Distance thresholds
    alignmentTolerance: 39, // Distance at which alignment lines appear
    snapThreshold: 7, // Distance at which objects snap (used for visual indication)

    // Visual configuration - General
    lineColor: 'rgba(169, 96, 211, 0.35)', // Default alignment line color
    snapIndicatorColor: 'rgba(255, 107, 0, 0.8)', // Orange color for snapped alignment lines
    lineWidth: 4, // Default alignment line width
    snappedLineWidthMultiplier: 1.2, // Multiplier for line width when snapped
    lineOffset: 4, // Extra length added to alignment lines beyond objects

    // Visual configuration - Object alignment
    objectAlignmentLineColor: 'rgba(169, 96, 211, 0.35)', // Light purple for object-to-object alignment
    aligningLineWidth: 4, // Thickness of alignment lines
    aligningLineOffset: 4, // Extra length added to alignment lines beyond objects

    // Visual configuration - Canvas center
    centerLineMargin: 30, // Distance for showing canvas center lines
    centerLineWidth: 5, // Thickness of canvas center lines

    // Feature toggles
    showAlignmentLines: true,
    enableObjectAlignment: true,
    enableCenterAlignment: true,
    enableEdgeAlignment: true,
  },
  video: {
    easeEffects: [
      {
        text: 'Linear',
        children: [
          {
            id: 'Linear',
            text: 'Linear',
          },
        ],
      },
      {
        text: 'Power1',
        children: [
          {
            id: 'Power1.easeIn',
            text: 'Power1.easeIn',
          },
          {
            id: 'Power1.easeInOut',
            text: 'Power1.easeInOut',
          },
          {
            id: 'Power1.easeOut',
            text: 'Power1.easeOut',
          },
        ],
      },
      {
        text: 'Power2',
        children: [
          {
            id: 'Power2.easeIn',
            text: 'Power2.easeIn',
          },
          {
            id: 'Power2.easeInOut',
            text: 'Power2.easeInOut',
          },
          {
            id: 'Power2.easeOut',
            text: 'Power2.easeOut',
          },
        ],
      },
      {
        text: 'Power3',
        children: [
          {
            id: 'Power3.easeIn',
            text: 'Power3.easeIn',
          },
          {
            id: 'Power3.easeInOut',
            text: 'Power3.easeInOut',
          },
          {
            id: 'Power3.easeOut',
            text: 'Power3.easeOut',
          },
        ],
      },
      {
        text: 'Power4',
        children: [
          {
            id: 'Power4.easeIn',
            text: 'Power4.easeIn',
          },
          {
            id: 'Power4.easeInOut',
            text: 'Power4.easeInOut',
          },
          {
            id: 'Power4.easeOut',
            text: 'Power4.easeOut',
          },
        ],
      },
      {
        text: 'Back',
        children: [
          {
            id: 'Back.easeIn',
            text: 'Back.easeIn',
          },
          {
            id: 'Back.easeInOut',
            text: 'Back.easeInOut',
          },
          {
            id: 'Back.easeOut',
            text: 'Back.easeOut',
          },
        ],
      },
      {
        text: 'Elastic',
        children: [
          {
            id: 'Elastic.easeIn',
            text: 'Elastic.easeIn',
          },
          {
            id: 'Elastic.easeInOut',
            text: 'Elastic.easeInOut',
          },
          {
            id: 'Elastic.easeOut',
            text: 'Elastic.easeOut',
          },
        ],
      },
      {
        text: 'Bounce',
        children: [
          {
            id: 'Bounce.easeIn',
            text: 'Bounce.easeIn',
          },
          {
            id: 'Bounce.easeInOut',
            text: 'Bounce.easeInOut',
          },
          {
            id: 'Bounce.easeOut',
            text: 'Bounce.easeOut',
          },
        ],
      },
      {
        text: 'Circ',
        children: [
          {
            id: 'Circ.easeIn',
            text: 'Circ.easeIn',
          },
          {
            id: 'Circ.easeInOut',
            text: 'Circ.easeInOut',
          },
          {
            id: 'Circ.easeOut',
            text: 'Circ.easeOut',
          },
        ],
      },
      {
        text: 'Expo',
        children: [
          {
            id: 'Expo.easeIn',
            text: 'Expo.easeIn',
          },
          {
            id: 'Expo.easeInOut',
            text: 'Expo.easeInOut',
          },
          {
            id: 'Expo.easeOut',
            text: 'Expo.easeOut',
          },
        ],
      },
      {
        text: 'Sine',
        children: [
          {
            id: 'Sine.easeIn',
            text: 'Sine.easeIn',
          },
          {
            id: 'Sine.easeInOut',
            text: 'Sine.easeInOut',
          },
          {
            id: 'Sine.easeOut',
            text: 'Sine.easeOut',
          },
        ],
      },
      {
        text: 'Strong',
        children: [
          {
            id: 'Strong.easeIn',
            text: 'Strong.easeIn',
          },
          {
            id: 'Strong.easeInOut',
            text: 'Strong.easeInOut',
          },
          {
            id: 'Strong.easeOut',
            text: 'Strong.easeOut',
          },
        ],
      },
    ],
  },
  attachmentsAllowedFileExtensions: [
    'png',
    'jpg',
    'jpeg',
    'svg',
    'gif',
    'tiff',
    'bmp',
  ],
};

export default editorConfig;
